export default {
  nameIsRequired: 'नाम की आवश्यकता है',
  emailIsRequired: 'ईमेल की आवश्यकता है',
  passwordIsRequired: 'पासवर्ड की आवश्यकता है',
  emailOrPhoneAreRequired: 'एक ईमेल या फोन डालें',
  onlyNumbers: 'फोन फ़ील्ड में केवल नंबरों की अनुमति है',
  passwordMin8: 'पासवर्ड में कम से कम 8 वर्ण होने चाहिए',
  habeasData: 'आपको नियम और शर्तों के समझौते को स्वीकार करना होगा',
  validEmail: 'एक वैध ईमेल डालें',
  validPhone: 'एक वैध फोन डालें',
  codeIsRequired: 'भेजा कोड आवश्यक है',
  newPasswordIsRequired: 'नया पासवर्ड आवश्यक है',
  confirmNewPassword: 'आपको अपने नए पासवर्ड की पुष्टि करनी चाहिए',
  passwordsDontMatch: 'पासवर्ड मेल नहीं खाते',
  fillCorrectlyFormFields: 'सभी फॉर्म फ़ील्ड को सही ढंग से भरें'
}
